import { isEmpty } from '@/utils/comparators'

const helpUrl = (locale) => {
  let url = process.env.WWW_URL
  switch (locale) {
    case 'es':
      url += '/es/ayuda/soporte/'
      break
    case 'fr':
      url += '/fr/aide/presentation/'
      break
    default:
      url += '/en/help/overview/'
      break
  }
  return url
}

const redirectHelpContactUrl = (locale) => {
  let url = process.env.WWW_URL
  switch (locale) {
    case 'es':
      url += '/es/ayuda/soporte/'
      break
    case 'fr':
      url += '/fr/aide/presentation/'
      break
    default:
      url += '/en/help/contact/'
      break
  }
  window.location.href = url
}

const redirectGenericMtuCmsPage = (locale) => {
  let url = process.env.WWW_URL
  switch (locale) {
    case 'es':
      url += '/es/campana/cms/mtu-generico/'
      break
    case 'fr':
      url += '/fr/campagne/cms/mtu-generique/'
      break
    default:
      url += '/en/campaign/cms/mtu-generic/'
      break
  }
  window.location.href = url
}

const redirectCubaProductPage = (locale) => {
  let url = process.env.WWW_URL
  switch (locale) {
    case 'es':
      url += '/es/cuba/recargas/'
      break
    case 'fr':
      url += '/fr/cuba/recharge/'
      break
    default:
      url += '/en/cuba/recharge/'
      break
  }
  window.location.href = url
}

const getComRoute = (locale, key, id = null) => {
  return isEmpty(id)
    ? `${process.env.WWW_URL}/${locale}/redirect/${key}`
    : `${process.env.WWW_URL}/${locale}/redirect/${key}/id/${id}`
}

export {
  helpUrl,
  redirectHelpContactUrl,
  getComRoute,
  redirectCubaProductPage,
  redirectGenericMtuCmsPage
}



// WEBPACK FOOTER //
// ./src/utils/redirectRebtelCom.js